export default __webpack_public_path__ + "static/Weird-585168d5c6985e782f4c7a61e86c4182.png";